import MainApp from './MainApp'
import Dashboard from './Dashboard'
import SRActivePasif from './SRActivePasif'
import NewSR from './NewSR'
import Mapping from './Mapping'
import CustomerCubic from './CustomerCubic'
import WMStatus from './WMStatus'
import ReadingResult from './ReadingResult'
import FinanceAudited from './FinanceAudited'
import MonthlyFinance from './MonthlyFinance'
import PaymentCustomer from './PaymentCustomer'
import WaterSale from './WaterSale'
import Personalia from './Personalia'
import Login from './Login'
import MappingSBG from './MappingSBG'
import Request from'./Request'
import Complaint from'./Complaint'
export {
    MainApp,
    Dashboard,
    SRActivePasif,
    NewSR,
    Mapping,
    CustomerCubic,
    WMStatus,
    ReadingResult,
    FinanceAudited,
    MonthlyFinance,
    PaymentCustomer,
    WaterSale,
    Personalia,
    Login,
    MappingSBG,
    Request,
    Complaint
}


// WEBPACK FOOTER //
// ./src/pages/index.js